(function () {
  'use strict';
  if (customElements.get('space-armory-cart')) return;
  const {CartStore, protectionVariant, checkoutReady, merchandise, isCoverage} = window.SpaceArmoryCartCore;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const safeURL = value => {
    try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) ? escape(url.href) : ''; } catch { return ''; }
  };
  class SpaceArmoryCart extends HTMLElement {
    connectedCallback() {
      if (this.store) return;
      this.config = JSON.parse(this.querySelector('[data-sa-cart-config]').textContent);
      this.config.root = `${this.config.root.replace(/\/$/, '')}/`;
      this.config.rate = this.config.currency === this.config.baseCurrency ? 1 : Number(window.Shopify?.currency?.rate);
      this.strings = this.config.strings;
      this.dialog = this.querySelector('#SaCartDialog');
      this.backdrop = this.querySelector('[data-sa-backdrop]');
      this.info = this.querySelector('#SaCheckoutInfo');
      this.body = this.querySelector('[data-sa-body]');
      this.footer = this.querySelector('[data-sa-footer]');
      this.summary = this.querySelector('[data-sa-summary]');
      this.express = this.querySelector('[data-sa-express]');
      if (this.express) {
        this.walletMedia = window.matchMedia('(max-width: 749px)');
        this.walletMedia.addEventListener?.('change', () => this.syncExpressLayout());
        this.walletObserver = new MutationObserver(() => this.syncExpressLayout());
        this.walletObserver.observe(this.express, {childList: true, subtree: true});
        this.syncExpressLayout();
      }
      this.productCache = new Map((this.config.products || []).filter(Boolean).map(product => [product.handle, product]));
      this.productRequests = new Map();
      this.store = new CartStore({
        config: this.config,
        request: this.request.bind(this),
        onChange: cart => this.render(cart),
        onBusy: busy => this.setBusy(busy),
        onError: message => this.showError(message),
      });
      if (Array.isArray(this.config.initialCart?.items)) {
        this.store.cart = this.config.initialCart;
        this.store.confirmedAt = Date.now();
        this.render(this.store.cart);
      }
      this.addEventListener('pointerdown', () => { this.dataset.saKeyboard = 'false'; });
      this.addEventListener('keydown', event => { if (['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) this.dataset.saKeyboard = 'true'; });
      this.addEventListener('click', event => this.handleClick(event));
      for (const type of ['contextmenu', 'dragstart']) {
        this.addEventListener(type, event => {
          if (event.target.closest?.('.sa-cart-protection-mark')) event.preventDefault();
        });
      }
      window.SpaceArmoryFitAccount?.addEventListener('change', () => { if(this.store.cart && !this.store.pending)this.render(this.store.cart); });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-sa-variant]');
        const quantity = event.target.closest('[data-sa-quantity]');
        if (this.store.mutating || this.profileUpdating || (!select && !quantity)) return;
        this.clearError();
        if (quantity && (!quantity.value.trim() || !Number.isInteger(Number(quantity.value)) || Number(quantity.value) < 1)) {
          this.showError(this.strings.invalid_quantity);
          this.render(this.store.cart);
          return;
        }
        const original = select && this.store.cart?.items.find(item => item.key === select.dataset.key);
        const patch = original && String(original.variant_id) !== String(select.value)
          ? {'_Size Selection Method': 'Variant changed manually in cart'} : undefined;
        const action = select ? this.store.swapVariant(select.dataset.key, select.value, patch) : this.store.setQuantity(quantity.dataset.key, Number(quantity.value));
        action.then(() => this.broadcast()).catch(error => { this.showError(error.message); this.render(this.store.cart); });
      });
      for (const dialog of [this.dialog, this.info]) {
        dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeDialog(dialog); });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog(dialog);
        });
      }
      this.dialog.addEventListener('keydown', event => {
        if (this.info.open) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key !== 'Tab') return;
        const elements = [...this.dialog.querySelectorAll('a[href],button,input,select,iframe,[tabindex]')].filter(el =>
          !el.disabled && el.tabIndex >= 0 && !el.closest('[hidden],[inert]') && el.getClientRects().length);
        const first = elements[0], last = elements[elements.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      document.addEventListener('click', event => {
        const link = event.target.closest('#cart-icon-bubble, [data-sa-open-cart]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(link);
      });
      document.addEventListener('keydown', event => {
        if (event.code === 'Space' && event.target.matches('#cart-icon-bubble')) { event.preventDefault(); this.open(event.target); }
      });
      const link = document.querySelector('#cart-icon-bubble');
      link?.setAttribute('aria-haspopup', 'dialog');
      link?.setAttribute('aria-controls', 'SaCartDialog');
      this.unsubscribe = typeof subscribe === 'function' && subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source === 'space-armory-cart' || event.source === 'product-form') return;
        this.store.refresh().catch(() => {});
      });
      window.addEventListener('pageshow', event => { this.navigating = false; this.setBusy(this.store.pending > 0); if (event.persisted) this.store.refresh().catch(() => {}); });
      document.addEventListener('visibilitychange', () => { if (!document.hidden && this.dialog.open) this.store.refresh({maxAge:15000}).catch(() => {}); });
      window.addEventListener('resize', () => this.updatePreviewOffset());
      this.updatePreviewOffset();
    }
    async request(route, body) {
      const abort = new AbortController();
      const timeout = setTimeout(() => abort.abort(), 20000);
      try {
        const form = body instanceof FormData;
        const response = await fetch(this.config.root + route, {
          method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store', signal: abort.signal,
          headers: {Accept: 'application/json', ...(body !== undefined && !form ? {'Content-Type':'application/json'} : {})},
          ...(body !== undefined ? {body: form ? body : JSON.stringify(body)} : {}),
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400 || data.errors) {
          throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.strings.network_error);
        }
        return data;
      } catch (error) {
        if (error.name === 'AbortError' || error instanceof TypeError) throw new Error(body === undefined ? this.strings.refresh_error : this.strings.network_error);
        throw error;
      } finally { clearTimeout(timeout); }
    }
    icon(name) { return this.querySelector(`[data-sa-icon="${name}"]`)?.innerHTML || ''; }
    syncExpressLayout() {
      const host = this.express?.querySelector('shopify-accelerated-checkout-cart');
      if (!host) return;
      const wallets = [...host.children].filter(el => el.slot?.startsWith('button-'));
      const limit = this.walletMedia.matches ? 3 : 4;
      if (this.walletLayoutHost === host && this.walletLayoutLimit === limit &&
          this.walletLayoutWallets?.length === wallets.length &&
          wallets.every((wallet, index) => this.walletLayoutWallets[index] === wallet)) return;
      this.walletLayoutHost = host;
      this.walletLayoutLimit = limit;
      this.walletLayoutWallets = wallets;
      const visible = Math.min(wallets.length, limit);
      // Keep Shopify's actual wallet elements mounted. Crop only surplus columns;
      // their inert state also removes them from keyboard and assistive navigation.
      // Shopify's horizontal component uses a 10px column gap.
      const ratio = visible ? wallets.length / visible : 1;
      host.style.width = ratio === 1 ? '100%' : `calc(${ratio * 100}% + ${(ratio - 1) * 10}px)`;
      wallets.forEach((wallet, index) => {
        const excluded = index >= limit;
        wallet.inert = excluded;
        if (excluded) wallet.setAttribute('aria-hidden', 'true');
        else wallet.removeAttribute('aria-hidden');
      });
    }
    money(cents) {
      return new Intl.NumberFormat(this.config.locale, {style:'currency', currency:this.store.cart?.currency || this.config.currency}).format(cents / 100);
    }
    image(product, width) {
      const source = product.featured_image?.url || product.featured_image || product.image?.url || product.image?.src || product.image || product.images?.[0]?.src || product.images?.[0];
      if (!source) return '';
      try { const url = new URL(source, location.origin); url.searchParams.set('width', width * 2); return safeURL(url.href); } catch { return ''; }
    }
    async loadProduct(handle) {
      if (this.productCache.has(handle)) return this.productCache.get(handle);
      if (!this.productRequests.has(handle)) {
        const request = this.request(`products/${encodeURIComponent(handle)}.js`).then(product => {
          this.productCache.set(handle, product); return product;
        }).finally(() => this.productRequests.delete(handle));
        this.productRequests.set(handle, request);
      }
      return this.productRequests.get(handle);
    }
    async changeFromCartPage(key, line, quantity, sections) {
      if (!key) { await this.store.refresh(); key = this.store.cart.items[Number(line) - 1]?.key; }
      if (!key) throw new Error(this.strings.refresh_error);
      await this.store.setQuantity(key, quantity);
      const url = new URL(location.pathname, location.origin);
      url.searchParams.set('sections', sections.join(','));
      const response = await fetch(url, {cache:'no-store', credentials:'same-origin'});
      const rendered = await response.json();
      return {text: async () => JSON.stringify({...this.store.cart, sections: rendered})};
    }
    getSectionsToRender() { return [{id:'cart-icon-bubble'}]; }
    setActiveElement(element) { this.activeElement = element; }
    addForm(formData, options) { this.clearError(); return this.store.addForm(formData, options); }
    renderContents() { this.open(this.activeElement, false); }
    open(trigger, refresh = true) {
      if (trigger && !this.contains(trigger)) this.setActiveElement(trigger);
      clearTimeout(this.closeTimer);
      this.dialog.classList.remove('sa-closing');
      if (this.backdrop) { this.backdrop.hidden = false; this.backdrop.classList.remove('sa-closing'); }
      this.updatePreviewOffset();
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.show();
        this.dialog.querySelector('[data-sa-close]').focus({preventScroll:true});
        document.dispatchEvent(new CustomEvent('space-armory:cart-open'));
      }
      if (this.store.mutating && !merchandise(this.store.cart || {items:[]}, this.config).length) this.body.innerHTML = `<p class="sa-cart-loading">${escape(this.strings.working)}</p>`;
      if (refresh || !this.store.cart) { this.clearError(); this.store.refresh({maxAge:15000}).catch(() => {}); }
    }
    close() { this.closeDialog(this.dialog); }
    closeDialog(dialog) {
      if (!dialog.open || dialog.classList.contains('sa-closing')) return;
      if (dialog === this.dialog && this.info.open) this.info.close();
      dialog.classList.add('sa-closing');
      if (dialog === this.dialog) this.backdrop?.classList.add('sa-closing');
      const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;
      const timer = setTimeout(() => {
        dialog.close(); dialog.classList.remove('sa-closing');
        if (dialog === this.dialog) {
          if (this.backdrop) this.backdrop.hidden = true;
          document.body.style.overflow = this.previousOverflow || '';
          if (this.activeElement?.isConnected) this.activeElement.focus({preventScroll:true});
          document.dispatchEvent(new CustomEvent('space-armory:cart-close'));
        } else this.footer.querySelector('[data-sa-info]')?.focus({preventScroll:true});
      }, delay);
      if (dialog === this.dialog) this.closeTimer = timer;
    }
    updatePreviewOffset() {
      const preview = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
      const rect = preview?.getBoundingClientRect();
      const offset = rect && rect.width && rect.height && rect.bottom >= innerHeight - 2 && rect.top > innerHeight / 2 ? innerHeight - rect.top : 0;
      this.style.setProperty('--sa-cart-preview-bottom', `${Math.max(0, offset)}px`);
    }
    setBusy(busy) {
      busy = busy || !!this.profileUpdating;
      const locked = busy && this.store.mutating > 0 || this.navigating || this.profileUpdating;
      this.body.setAttribute('aria-busy', String(busy));
      this.dialog.dataset.saBusy = String(busy);
      this.dialog.dataset.saMutating = String(!!locked);
      this.querySelectorAll('[data-sa-mutates]').forEach(button => {
        button.disabled = locked || button.dataset.unavailable === 'true';
        button.setAttribute('aria-busy', String(!!locked));
        if (!locked) delete button.dataset.saLoading;
      });
      if (this.express) {
        const disabled = busy || this.navigating || this.store.unconfirmed || !checkoutReady(this.store.cart, this.config);
        this.express.inert = !!disabled;
        this.express.setAttribute('aria-disabled', String(!!disabled));
        this.express.setAttribute('aria-busy', String(!!locked));
      }
      if (!busy && this.pendingFocus?.isConnected && this.dialog.open && !this.info.open) {
        this.pendingFocus.focus({preventScroll:true});
        this.pendingFocus = null;
      }
    }
    showError(message) {
      const error = this.querySelector('[data-sa-error]');
      error.textContent = message;
      error.hidden = false;
      if (!this.store.cart) {
        this.body.innerHTML = `<div class="sa-cart-empty"><button type="button" class="sa-cart-checkout" data-sa-retry>${escape(this.strings.retry)}</button></div>`;
      }
    }
    clearError() { this.querySelector('[data-sa-error]').hidden = true; }
    render(cart) {
      if (!cart) return;
      const items = merchandise(cart, this.config);
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      const focused = document.activeElement?.dataset;
      const focusKey = focused?.key;
      const focusAction = focused?.saAction;
      const focusProtection = document.activeElement?.hasAttribute('data-sa-protection');
      const scroll = this.body.scrollTop;
      this.querySelector('[data-sa-count]').textContent = count;
      this.body.innerHTML = items.length ? items.map(item => this.renderItem(item)).join('') + this.renderUpsells(items) : `<div class="sa-cart-empty"><h3>${escape(this.strings.empty)}</h3><button type="button" class="sa-cart-checkout" data-sa-close>${escape(this.strings.continue_shopping)}</button></div>`;
      this.body.scrollTop = scroll;
      this.footer.hidden = !items.length;
      if (items.length) this.renderFooter(cart);
      this.setBusy(this.store.pending > 0);
      this.querySelector('[data-sa-status]').textContent = `${this.strings.updated}. ${count}`;
      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (bubble) {
        bubble.hidden = !count;
        const visible = bubble.querySelector('[aria-hidden]'); if (visible) visible.textContent = count < 100 ? count : '';
        const sr = bubble.querySelector('.visually-hidden'); if (sr) sr.textContent = String(count);
      } else if (count) {
        document.querySelector('#cart-icon-bubble')?.insertAdjacentHTML('beforeend', `<div class="cart-count-bubble"><span aria-hidden="true">${count < 100 ? count : ''}</span><span class="visually-hidden">${count}</span></div>`);
      }
      if (focusKey && this.dialog.open && !this.info.open) {
        const next = [...this.querySelectorAll('[data-sa-action]')].find(element => element.dataset.key === focusKey && element.dataset.saAction === focusAction);
        this.pendingFocus = next || this.dialog.querySelector('[data-sa-close]');
      }
      if (focusProtection && this.dialog.open && !this.info.open) this.pendingFocus = this.querySelector('[data-sa-protection]');
      const missing = items.filter(item => !this.productCache.has(item.handle));
      if (missing.length) Promise.allSettled(missing.map(item => this.loadProduct(item.handle))).then(results => {
        if (this.store.cart === cart && results.some(result => result.status === 'fulfilled')) this.render(cart);
      });
    }
    profileUpdateButton(item) {
      const state=window.SpaceArmoryFitAccount?.state;
      const rules=window.SpaceArmoryFitRules;
      if(state?.status!=='ready' || !rules?.valid(state.measurement) || !item.properties?.['Measured Size'] || item.properties['Measured Size']===rules.text(state.measurement))return '';
      return `<button type="button" class="sa-cart-profile-update" data-sa-mutates data-sa-profile-update data-key="${escape(item.key)}">Use my saved measurement — ${escape(rules.sizeFor(state.measurement.cm))}</button>`;
    }
    async updateMeasurement(key) {
      if(this.store.pending || this.profileUpdating)return;
      this.profileUpdating=true;
      this.setBusy(true);
      try {
        const state=await window.SpaceArmoryFitAccount.refresh();
        const rules=window.SpaceArmoryFitRules;
        if(!rules.valid(state.measurement))throw new Error('No saved measurement is available.');
        await this.store.refresh();
        const item=this.store.cart.items.find(item=>item.key===key);
        if(!item)throw new Error('This item changed. Please review your cart.');
        const product=await this.loadProduct(item.handle);
        const index=product.options.findIndex(option=>/^(size|fit|beden|size fit)$/i.test(typeof option==='string'?option:option.name));
        const original=product.variants.find(variant=>String(variant.id)===String(item.variant_id));
        const size=rules.sizeFor(state.measurement.cm);
        const aliases={S:['s','small'],M:['m','medium'],L:['l','large'],XL:['xl','x-large','extra large'],XXL:['xxl','2xl','xx-large','extra extra large']};
        const options=variant=>variant.options || [variant.option1,variant.option2,variant.option3].filter(value=>value!=null);
        const target=original && index>=0 && product.variants.find(variant=>options(variant).every((value,i)=>i===index?aliases[size].includes(value.toLowerCase()):value===options(original)[i]));
        if(!target?.available)throw new Error('Your saved size is unavailable in this configuration. Your item has not changed.');
        const check=await window.SpaceArmoryFitAccount.refresh();
        if(check.customer!==state.customer || check.revision!==state.revision)throw new Error('Your saved measurement changed. Please try again.');
        const stats = Object.fromEntries((rules.scanStatsKeys || []).map(key => [key,null]));
        Object.assign(stats, rules.scanStatsProperties?.(state.measurement.scanStats));
        await this.store.swapVariant(key,target.id,{'Measured Size':rules.text(state.measurement),'_Face Fit Profile Revision':String(state.revision),'_Face Fit Measurement':null,'_Face Fit Device':null,'_Face Fit Source':`saved_profile | ${rules.version}`,'_Face Fit Action':'Use saved measurement in cart','_Size Selection Method':'Saved measurement applied in cart',...stats});
        this.broadcast();
      } catch(error){this.showError(error.message);} finally {this.profileUpdating=false;this.setBusy(this.store.pending>0);}
    }
    cartTitle(item) {
      const full = String(item.product_title || item.title || '');
      const match = full.match(/^(.*?)\s+[-–—]\s+(.+)$/);
      return match ? {name: match[1].trim(), color: match[2].trim()} : {name: full, color: ''};
    }
    variantText(product, variant, fallback) {
      const values = variant?.options || [variant?.option1, variant?.option2, variant?.option3].filter(value => value != null);
      const names = (product?.options || []).map(option => typeof option === 'string' ? option : option.name);
      if (!names.length || names.length !== values.length) return fallback || variant?.title || '';
      return names.map((name, index) => {
        const normalized = name.trim();
        const label = /^size$/i.test(normalized) ? 'Size' : normalized === 'Elastic Buckle - Straw Rope ?' ? 'Strap' : normalized;
        return /^title$/i.test(label) ? values[index] : `${label}: ${values[index]}`;
      }).join(' / ');
    }
    renderItem(item) {
      const product = this.productCache.get(item.handle);
      const variants = product?.variants;
      const display = this.cartTitle(item);
      const title = escape(display.name);
      const properties = Object.entries(item.properties || {}).filter(([key,value]) => value && !key.startsWith('_')).map(([key,value]) => `<div>${escape(key)}: ${escape(value)}</div>`).join('');
      const sellingPlan = item.selling_plan_allocation?.selling_plan?.name;
      const selectedVariant = variants?.find(variant => String(variant.id) === String(item.variant_id));
      const variantLabel = this.variantText(product, selectedVariant, item.variant_title);
      let variant = variants?.length > 1 ? `<select class="sa-cart-variant"  data-sa-variant data-sa-mutates data-sa-action="variant" data-key="${escape(item.key)}" aria-label="${escape(this.strings.variant)}: ${title}">${variants.map(variant => `<option value="${variant.id}"${String(variant.id) === String(item.variant_id) ? ' selected' : ''}${!variant.available ? ' disabled' : ''}>${escape(this.variantText(product, variant, variant.title))}${!variant.available ? ` — ${escape(this.strings.sold_out)}` : ''}</option>`).join('')}</select>` : item.variant_title && item.variant_title !== 'Default Title' ? `<span class="sa-cart-variant">${escape(variantLabel)}</span>` : '';
      if (variants?.length > 1) {
        variant = `<div class="sa-cart-variant-wrap"><span class="sa-cart-variant-value" aria-hidden="true">${escape(variantLabel)}<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="m3 4.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></span>${variant}</div>`;
      }
      const price = item.final_line_price;
      return `<article class="sa-cart-item" data-sa-line="${escape(item.key)}">
        <a href="${safeURL(item.url)}" tabindex="-1" aria-hidden="true"><img class="sa-cart-image" src="${this.image(item,100)}" width="100" height="100" alt="${title}"></a>
        <div class="sa-cart-item-details"><a class="sa-cart-item-title" href="${safeURL(item.url)}">${title}</a>${variant}${display.color ? `<div class="sa-cart-color">Color: ${escape(display.color)}</div>` : ''}
        ${this.profileUpdateButton(item)}
        ${properties || sellingPlan ? `<div class="sa-cart-properties">${properties}${sellingPlan ? `<div>${escape(sellingPlan)}</div>` : ''}</div>` : ''}
        ${(item.line_level_discount_allocations || []).map(discount => `<div class="sa-cart-discount">${escape(discount.discount_application.title)} (−${escape(this.money(discount.amount))})</div>`).join('')}
        <div class="sa-cart-item-bottom"><div class="sa-cart-quantity">
          <button type="button" data-sa-mutates data-sa-action="decrease" data-key="${escape(item.key)}" data-unavailable="${item.quantity <= 1}" aria-label="${escape(this.strings.decrease)}: ${title}">${this.icon('minus')}</button><input type="number" inputmode="numeric" min="1" step="1" value="${item.quantity}" style="width:${Math.min(42, Math.max(16, String(item.quantity).length * 10))}px" aria-label="Quantity: ${title}" data-sa-quantity data-sa-mutates data-sa-action="quantity" data-key="${escape(item.key)}">
          <button type="button" data-sa-mutates data-sa-action="increase" data-key="${escape(item.key)}" aria-label="${escape(this.strings.increase)}: ${title}">${this.icon('plus')}</button>
        </div><div class="sa-cart-price">${item.original_line_price > price ? `<s>${escape(this.money(item.original_line_price))}</s>` : ''}${escape(this.money(price))}</div></div></div>
        <button type="button" class="sa-cart-icon-button sa-cart-remove" data-sa-mutates data-sa-action="remove" data-key="${escape(item.key)}" aria-label="${escape(this.strings.remove)}: ${title}">${this.icon('remove')}</button></article>`;
    }
    renderUpsells(items) {
      const neckwearBundles = new Set(this.config.neckwearBundleProductIds || []);
      if (items.some(item => neckwearBundles.has(String(item.product_id)))) return '';
      const products = (this.config.upsells || []).filter(product => product?.id && !items.some(item => String(item.product_id) === String(product.id)));
      if (!products.length) return '';
      return `<section class="sa-cart-upsells"><h3>${escape(this.config.upsellHeading)}</h3>${products.map(product => {
        const variant = product.variants.find(variant => variant.available) || product.variants[0];
        return `<article class="sa-cart-upsell"><a href="${this.config.root}products/${encodeURIComponent(product.handle)}" tabindex="-1" aria-hidden="true"><img src="${this.image(product,92)}" alt="${escape(product.title)}" width="92" height="92"></a><div class="sa-cart-upsell-content"><a class="sa-cart-upsell-name" href="${this.config.root}products/${encodeURIComponent(product.handle)}">${escape(product.title)}</a><div class="sa-cart-price">${escape(this.money(variant.price))}</div><button type="button" class="sa-cart-add" data-sa-mutates data-sa-add="${variant.id}" data-unavailable="${!variant.available}">${escape(variant.available ? this.strings.add : this.strings.sold_out)}</button></div></article>`;
      }).join('')}</section>`;
    }
    renderShipping(cart) {
      if (!merchandise(cart, this.config).some(item => item.requires_shipping)) return '';
      const free = this.config.freeStandardShippingCountries?.includes(this.config.countryCode) === true;
      return `<div class="sa-cart-shipping"><dt>${escape(this.strings.shipping)}</dt><dd data-sa-shipping>${escape(free ? this.strings.free : this.strings.at_checkout)}</dd></div>`;
    }
    renderFooter(cart) {
      const target = protectionVariant(cart, this.config);
      const coverage = cart.items.filter(item => isCoverage(item, this.config));
      const fee = coverage.length ? coverage.reduce((sum,item) => sum + item.final_line_price,0) : target?.price || 0;
      const selected = coverage.length > 0;
      const protectionIcon = this.icon('protection');
      const subtotal = merchandise(cart, this.config).reduce((sum, item) => sum + item.final_line_price, 0);
      const discounts = (cart.cart_level_discount_applications || []).map(discount => `<p class="sa-cart-discount">${escape(discount.title)} (−${escape(this.money(discount.total_allocated_amount))})</p>`).join('');
      this.summary.innerHTML = `<dl class="sa-cart-totals"><div><dt>${escape(this.strings.subtotal)}</dt><dd data-sa-subtotal>${escape(this.money(subtotal))}</dd></div>${this.renderShipping(cart)}</dl>${discounts}${target || selected ? `<div class="sa-cart-protection">${protectionIcon}<div><div class="sa-cart-protection-heading">Checkout+ <button type="button" class="sa-cart-icon-button sa-cart-info-button" data-sa-info aria-label="${escape(this.strings.info)}">${this.icon('info')}</button></div><p>${escape(this.config.protectionText)}</p></div><div class="sa-cart-protection-actions"><span class="sa-cart-protection-price">${escape(this.money(fee))}</span><button type="button" class="sa-cart-switch" role="switch" aria-checked="${selected}" aria-label="${escape(this.strings.protection_toggle)}" data-sa-protection data-sa-mutates><span class="sa-cart-switch-spinner" aria-hidden="true"></span></button></div></div>` : ''}
        <button type="button" class="sa-cart-checkout" data-sa-mutates data-sa-checkout="${selected ? 'protected' : 'standard'}">${this.icon('lock')}<span>${selected ? 'Checkout+' : escape(this.strings.checkout)} • ${escape(this.money(cart.total_price))}</span></button>`;
    }
    broadcast() {
      if (typeof publish === 'function') Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source:'space-armory-cart', cartData:this.store.cart})).catch(console.error);
      this.dispatchEvent(new CustomEvent('space-armory:cart-updated', {bubbles:true, detail:{cart:this.store.cart}}));
    }
    async handleClick(event) {
      if (event.target.closest('[data-sa-close]')) { this.close(); return; }
      if (event.target.closest('[data-sa-info-close]')) { this.closeDialog(this.info); return; }
      if (event.target.closest('[data-sa-info]')) { this.info.showModal(); return; }
      if (event.target.closest('[data-sa-retry]')) { this.store.refresh().catch(() => {}); return; }
      const control = event.target.closest('[data-sa-mutates]');
      if (!control || control.matches('select, input') || this.store.mutating || this.navigating || this.profileUpdating) return;
      if (control.hasAttribute('data-sa-profile-update')) { this.clearError(); await this.updateMeasurement(control.dataset.key); return; }
      control.dataset.saLoading = 'true';
      this.clearError();
      try {
        if (control.dataset.saCheckout) {
          const protectedCheckout = control.dataset.saCheckout === 'protected';
          const expected = this.store.cart.total_price;
          this.navigating = true;
          await this.store.checkout(protectedCheckout);
          if (this.store.unconfirmed) { this.navigating = false; this.setBusy(false); return; }
          if (this.store.cart.total_price !== expected) { this.navigating = false; this.setBusy(false); this.showError(this.strings.price_changed); this.broadcast(); return; }
          this.broadcast();
          window.location.assign(`${this.config.root}checkout`);
          return;
        }
        if (control.hasAttribute('data-sa-protection')) await this.store.setProtection(control.getAttribute('aria-checked') !== 'true');
        else if (control.dataset.saAdd) await this.store.add(control.dataset.saAdd, 1, {'_Added From': 'Cart drawer recommendation'});
        else {
          const item = this.store.cart?.items.find(item => item.key === control.dataset.key);
          if (!item) return;
          const action = control.dataset.saAction;
          if (!['remove', 'increase', 'decrease'].includes(action)) return;
          await this.store.setQuantity(item.key, action === 'remove' ? 0 : item.quantity + (action === 'increase' ? 1 : -1));
        }
        this.broadcast();
      } catch { this.navigating = false; this.setBusy(this.store.pending > 0); }
    }
  }
  customElements.define('space-armory-cart', SpaceArmoryCart);
})();
